import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { ApplyButton, JobSearch } from "../../../../Constants/Constants";
import LeftSidebar from "../Common/LeftSidebar/LeftSidebar";
import ApplyForm from "./ApplyForm/ApplyForm";
import { Fragment } from "react/jsx-runtime";

const ApplyJobsContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={ApplyButton} parent={JobSearch} />
      <Container fluid>
        <Row>
          <LeftSidebar />
          <ApplyForm />
        </Row>
      </Container>
    </Fragment>
  );
};
export default ApplyJobsContainer;
